import type { ApiUrlKey } from '@/shared/config';

/** As cinco APIs do legado (`BaseApiResource` em services/axiosApi). */
export type ApiName = 'CreditApi' | 'BillingApi' | 'SearchApi' | 'ChatbotApi' | 'BankingApi';

export const API_URL_KEYS: Record<ApiName, ApiUrlKey> = {
  CreditApi: 'CREDIT_API_URL',
  BillingApi: 'BILLING_API_URL',
  SearchApi: 'SEARCH_API_URL',
  ChatbotApi: 'CHATBOT_API_URL',
  BankingApi: 'BANKING_API_URL',
};

/** Timeout padrão da instância (16 s). Chamada lenta sobrescreve com `timeout`, como no legado. */
export const DEFAULT_TIMEOUT_MS = 16_000;

/** Overrides que o legado usa por chamada (`utils/constants/timeoutInMilliseconds.ts`). */
export const TIMEOUTS = {
  s30: 30_000,
  s45: 45_000,
  s90: 90_000,
  min2: 120_000,
  min5: 300_000,
  /** `TIMEOUT_INFINITE` do legado: sem timeout. */
  infinite: 0,
} as const;

/** APIs que recebem `X-UY3-Client-Geo` no legado; ChatbotApi fica fora. */
export const GEO_TRACKED_APIS: readonly ApiName[] = ['CreditApi', 'BillingApi', 'SearchApi', 'BankingApi'];
export const GEO_TRACKED_METHODS: readonly string[] = ['post', 'put', 'patch', 'delete'];
